import type { IMapOptions } from '@components/Maps/mapOptions'
import Logger from '@logger'
import { has } from 'lodash'

const logger = Logger.create('WindyLoader')

const isWindyLoaded = (window: Window) => has(window, 'W.version')

const isLeafletLoaded = (window: Window) => has(window, 'L.version')

let shouldLoadWindy = true
let shouldImportLeaflet = true
let script: HTMLScriptElement

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let windyInstance: any = null
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let windyStore: any = null
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let windyColors: any = null

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let copyOfW: any = null

export default class WindyLoader {
  static async initWindyOnce (
    options: IMapOptions
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ): Promise<{ map: any; store: any; colors: any }> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const win: any = window

    if (!copyOfW && win.W) {
      copyOfW = Object.assign({}, win.W)
    }

    if (win.W.windyBoot) {
      win.W = Object.assign({}, copyOfW)
    }

    if (windyInstance && windyStore && windyColors) {
      return { map: windyInstance, store: windyStore, colors: windyColors }
    }

    return await new Promise((resolve, reject) => {
      // @ts-expect-error cannot find function, module loaded from script
      windyInit(options, ({ map, store, colors }) => {
        console.log('windyInit.colors', colors)
        if (!map) {
          reject(new Error('no map created in windyInit method, exiting'))
        } else if (!store) {
          reject(new Error('no store created in windyInit method, exiting'))
        } else {
          windyStore = store
          windyInstance = map
          windyColors = colors
          resolve({
            map: windyInstance,
            store: windyStore,
            colors: windyColors
          })
        }
      })
    })
  }

  static loadWindy (window: Window, context: string) {
    return new Promise<void>(resolve => {
      let didSetupWindy = isWindyLoaded(window)
      let didSetupLeaflet = isLeafletLoaded(window)

      const trySetupWindy = () => {
        if (!didSetupLeaflet) {
          didSetupLeaflet = isLeafletLoaded(window)

          if (!didSetupLeaflet && shouldImportLeaflet) {
            shouldImportLeaflet = false
            logger.debug(`${context}: importing Leaflet`)
            import('leaflet').then(() => logger.debug(`${context}: Leaflet imported`))
          }

          return
        }

        if (!didSetupWindy && shouldLoadWindy) {
          shouldLoadWindy = false
          logger.debug(`${context}: adding Windy script`)
          script = document.createElement('script')
          script.src = 'https://api.windy.com/assets/map-forecast/libBoot.js'
          script.async = true
          document.body.appendChild(script)

          script.onload = () => logger.debug(`${context}: Windy script loaded`)

          return
        }

        didSetupWindy = isWindyLoaded(window)

        if (didSetupWindy && didSetupLeaflet) {
          clearInterval(timeoutId)
          logger.debug(`${context}: Windy ready to use`)
          resolve()
        }
      }

      const timeoutId = setInterval(trySetupWindy, 50)
    })
  }
}
